
const reqCode = {
  SUCCESS: '0',
  ERROR: '1',
  TIMEOUT: '2',
  PERMISSION_NOT_FOUND: '3'
};

const dialogAction = {
  ADD: 'add',
  EDIT: 'edit',
  INFO: 'info'
};

export {
  reqCode,
  dialogAction
}



// WEBPACK FOOTER //
// ./src/common/const.js